module.exports = __webpack_public_path__ + "img/columnarIcon2.66540621.svg";